import * as React from "react"

import t from "@/constants/wording"
import Layout from "@/components/layout"
import Seo from "@/components/seo"
import { HeaderBar } from "@/components/header-bar/joint-solution-header-bar"
import AllJointSolutions from "@/components/joint-solution/all-card"
import ContactUs from "@/components/solution/contact-us"

interface IProps {
  location: ILocation
}

const JointSolutionPage: React.FC<IProps> = ({ location }) => {
  return (
    <Layout>
      <Seo
        title={t("Joint solution")}
        description={t("Reshape the business model with technology")}
        keywords={t("keywords")}
      />
      <HeaderBar title={t("Joint solution")} />
      <AllJointSolutions />
      <ContactUs location={location} />
    </Layout>
  )
}

export default JointSolutionPage
